import { render } from "./PendingApprovalPendingCases.vue?vue&type=template&id=70a46edd"
import script from "./PendingApprovalPendingCases.vue?vue&type=script&lang=js"
export * from "./PendingApprovalPendingCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pendingCases/PendingApprovalPendingCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70a46edd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70a46edd', __exports__)) {
    console.log('reload')
    api.reload('70a46edd', __exports__)
  }
  
  module.hot.accept("./PendingApprovalPendingCases.vue?vue&type=template&id=70a46edd", () => {
    console.log('re-render')
    api.rerender('70a46edd', render)
  })

}


export default __exports__